import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  filtersPaperChildContainer: {
    padding: theme.spacing(2),
  },
  filtersTitle: {
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.body1.fontFamily,
    marginBottom: theme.spacing(1),
  },
}));
